import { FORMAT_DATE, CONVERSIONTABLE, DEAL_TIME, PROFILETYPE_FILTER } from './util'
import { sakura } from './sakura';

const $sakura = sakura;

export function dates(value) {
  return FORMAT_DATE(value, 'yyyy-MM-dd');
}

export function dateFormat(value, format) {
  return FORMAT_DATE(value, format);
}

export function dateTime(value, separator) {
  return DEAL_TIME(value, separator);
}

export function date(value) {
  return FORMAT_DATE(value * 1000, 'yyyy-MM-dd');
}

export function dateTimeHm(value) {
  return FORMAT_DATE(value * 1000, 'yyyy-MM-dd hh:mm');
}

export function dateTimeHms(value) {
  return FORMAT_DATE(value * 1000, 'yyyy-MM-dd hh:mm:ss');
}

export function dateTimeHms_business(value) {
  return FORMAT_DATE(value, 'yyyy-MM-dd hh:mm:ss');
}

export function desensitization(value) {
  return value ? value.replace(/\S/g, '*') : '';
}

export function showData(value, isdefault = '-') {
  return value ? value : isdefault;
}

export function conversion(val, list, key, value, reverse) {
  return CONVERSIONTABLE(list, val, key, value, reverse);
}

export function transformDate(value) {
  if (value) {
    value = FORMAT_DATE(value, 'yyyy-MM-dd');
    if (value >= '2036-01-01') {
      value = '2035-12-31';
    } else if (value <= '1969-01-01') {
      value = '1970-12-31';
    }
    let dt = FORMAT_DATE(value, 'MM dd,yyyy');
    let m = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let arr = dt.split(' ');
    arr[0] = m[parseInt(arr[0]) - 1];
    return arr.join(' ');
  }
  return '';
}

export function mb(value) {
  if (value) {
    if (value < 1024) {
      return `${value}bits/sec`;
    } else if (value < 1048576) {
      return `${parseFloat((value / 1024).toFixed(0))}KB/sec`;
    } else {
      return `${parseFloat((value / (1024 * 1024)).toFixed(0))}MB/sec`;
    }
  }
  return 0;
}

export function w(value) {
  return value ? parseFloat((value / 1000).toFixed(0)) : 0;
}

export function profileType(value, locale) {
  return CONVERSIONTABLE($sakura.locale.conversion.profileType_filter, value);
}

export function template(value, source, target) {
  return value === source ? target : value;
}

export function templates(value) {
  return PROFILETYPE_FILTER(value);
}

// Dynamic conversion filters from locale
export function getDynamicConversionFilters(locale) {
  const filters = {};

  Object.keys($sakura.locale.conversion).forEach(key => {
    filters[key] = function (value) {
      return CONVERSIONTABLE($sakura.locale.conversion[key], value);
    };
  });

  return filters;
}
